export const PACKAGE_PREFIX = 'universal-create';
export const TRIGGER_BUTTON_SPOTLIGHT_TARGET: 'universal-create-trigger-button-target' = `${PACKAGE_PREFIX}-trigger-button-target`;
export const TRIGGER_BUTTON_TEST_ID: 'universal-create-trigger-button' = `${PACKAGE_PREFIX}-trigger-button`;
export const ANALYTICS_CHANNEL = 'navigation';
export const MAX_ALLOWED_SECTIONS = 3;
export const SOURCE_LOCATION = 'universal-create';
export const REQUIRED_USER_ITEMS: string[] = [
	'ati:cloud:townsquare:team',
	'ati:cloud:townsquare:goal',
];

export const MAX_MENU_HEIGHT = 344;

/**
 * Increased menu height used under the gate navx-4607-increase-uc-menu-max-height to accommodate additional items.
 * Can be cleaned up once the gate is rolled out and MAX_MENU_HEIGHT is updated accordingly.
 */
export const MAX_MENU_HEIGHT_EXPANDED = 430;

export const RESPONSIVE_BREAKPOINT = 'sm';

/**
 * Sentinel index for the primary action item injected on mobile viewports.
 * Uses -1 to avoid colliding with the 0-based indices of regular section items.
 */
export const PRIMARY_ACTION_ITEM_INDEX = -1;
